import { Sidebar } from 'react-admin';
//TODO: move styles to a separate file if possible
export const MySidebar = (props: any) => (
  <Sidebar
    {...props}
    sx={{
      '& .RaSidebar-fixed': {
        top: 72,
        height: '100vh',
        bgcolor: 'var(--color-background-alt)',
        width: '280px !important',
      },
      '& .MuiList-root': {
        p: 2,
        width: '280px !important',
      },
      '& .MuiPaper-root': {
        width: '280px !important',
      },
    }}
  />
);
